<template>
  <div class="Footer">
    <div class="wrapper">
      <h3>Let's make something great together.</h3>
      <div class="contact">Contact me at <a mailto="mike@mikecassie.com">mike@mikecassie.com</a> or at 1-250-537-6695.</div>
      <div class="links">
        <a href="https://www.linkedin.com/in/mike-cassie/" target="_blank" class="linkedin"><img src="/assets/ui/linkedin-in.svg" alt="LinkedIn"></a>
        <a href="https://www.dropbox.com/s/5qeymr6m9mn0qxl/Mike-Cassie-CV.pdf" target="_blank" class="cv">CV</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss" scoped>
.Footer {
  width: 100%;
  // border-top: 1px solid #000;
  // margin: 100px 0 0 0;
  padding: 80px 0;
  @include fontBodyLight;
  background: $greyLight;

  & .wrapper {
    @include siteWrapper;
    text-align: center;

    & h3 {
      @include fontHeadItalic;
      font-size: 36px;
      line-height: 56px;
      margin: 0 0 40px 0;
    }
    & .contact {
      font-size: 18px;
      margin: 0 0 40px 0;

      & a {
        display: inline-block;
        display: inline-block;
        position: relative;
        text-decoration: none;
        transition: all 200ms;

        &::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 5px;
          width: 100%;
          height: 1px;
          background: #000;
        }

        &:hover {
          &::after {
            background: #fff;
          }
        }
      }
    }
    & .links {
      display: flex;
      align-items: center;
      justify-content: center;

      & a {
        border: 1px solid #000;
        border-radius: 4px;
        text-transform: uppercase;
        text-align: center;
        text-decoration: none;
        margin: 0 15px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 32px;
        height: 32px;
        position: relative;

        &:hover {
          background: #fff;
          color: #000;
        }
        &.linkedin {
          & img {
            width: 19px;
            height: 19px;
            display: block;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
          }
        }
        &.cv {
          @include fontBodyBold;
          font-size: 17px;
          line-height: 16px;
          text-align: center;
        }
      }
    }
  }
  @media screen and (max-width: $breakSmall) {
    margin: 60px 0 0 0;
    padding: 60px 0;

    & .wrapper {
      width: calc(100% - 40px);

      & h3 {
        @include fontHeadItalic;
        font-size: 34px;
        line-height: 48px;
      }
      & .contact {
        font-size: 18px;
        margin: 0 0 25px 0;
      }
    }
  }
}
</style>
